import React, {
  useState,
  useRef,
  useContext
} from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import SpecialtyContext from './context';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import List from '~/containers/List';
import Request from '~/providers/Request';
import ModalDelete from '~/components/ModalDelete';
import {
  showSpecialty,
  editSpecialty,
  createSpecialty
} from '~/config/routes';
import moment from 'moment';
import { AbilityContext } from '~/contexts/Can';

function SpecialtyList() {
  const { t } = useTranslation();
  const [modalInfo, setModalInfo] = useState({ show: false });
  const { delRecord } = useContext(SpecialtyContext);
  const ability = useContext(AbilityContext);
  const listEl = useRef(null);

  const trAttr = (attr) => t(`specialties.attributes.${attr}`);

  function handleDeletionModal(id, title){
    setModalInfo({ show: true, id, title });
  }

  async function handleDelete(){
    try {
      await Request.del(`/admin/specialties/${modalInfo.id}`);
      delRecord(modalInfo.id);
      listEl.current.onQueryChange();
      toast.success(t('delete-toast-success'));
    } catch(e) {
      toast.error(t('delete-toast-fail'));
    } finally {
      setModalInfo({ show: false });
    }
  }

  const actions = [
    'search',
    'filter',
  ];

  if(ability.can('new', 'Specialties')) {
    actions.push('new');
  }
  if(ability.can('edit', 'Specialties')) {
    actions.push('edit');
  }
  if(ability.can('delete', 'Specialties')) {
    actions.push('del');
  }
  if(ability.can('show', 'Specialties')) {
    actions.push('show');
  }

  return (
    <div>
      <List
        deleteAction={handleDeletionModal}
        routeToNew={createSpecialty}
        routeToEdit={editSpecialty}
        routeToShow={showSpecialty}
        listEl={listEl}
        path={'/admin/specialties/'}
        actions={actions}
        paperProps={{
          Icon: LocalHospitalIcon,
          iconColor: 'blue',
          title: t('specialties.defPlural'),
        }}
        columns={[
          { title: trAttr('id'), field: 'id', type: 'numeric', precision: 0, includeThousandsSeparator: false },
          { title: trAttr('name'), field: 'name', type: 'string' },
          { title: trAttr('is_active'), field: 'is_active', type: 'boolean' },
          { title: trAttr('external_id_ids'), field: 'external_id_ids', type: 'string' },
          { title: trAttr('created_at'), field: 'created_at', type: 'datetime' },
          { title: trAttr('updated_at'), field: 'updated_at', type: 'datetime' },
        ]}
        context={SpecialtyContext}
        recordMap={
          record => ({
            ...record,
            created_at: record.created_at ? moment(record.created_at).format('DD/MM/YYYY HH:mm') : null,
            updated_at: record.updated_at ? moment(record.updated_at).format('DD/MM/YYYY HH:mm') : null,
          })
        }
      />

      <ModalDelete
        id={modalInfo.id}
        name={modalInfo.title}
        modal={modalInfo.show}
        deleteAction={handleDelete}
        onClose={() => setModalInfo({ show: false })}
      />
    </div>
  );
}

export default React.memo(SpecialtyList);
